export default [
    {
        // [0]
        key: "selected",
        label: "",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "empleado",
        label: app.$i18n.t("Employee"),
        sortable: true,
        visible: true,
        stickyColumn: true,
        isRowHeader: true,
    },
    {
        // [1]
        key: "area",
        label: "Area",
        sortable: false,
        visible: true,
    },
    {
        key: "fecha_cese",
        label: "Info. Cese",
        sortable: false,
        visible: true,
    },
    {
        // [2]
        key: "document_number",
        label: app.$i18n.t("Document Number"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: false,
        visible: true,
    },
    {
        // [3]
        key: "type_form",
        label: "Contrato",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "labor_regimen",
        label: "Regimen Laboral",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [5]
        key: "payment_method",
        label: app.$i18n.t("Payment Method"),
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [6]
        key: "tiene_otro_pago",
        label: "PAGO ADICIONAL",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [7]
        key: "salary_per_month",
        label: app.$i18n.t("Salary"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [8]
        key: "bonification",
        label: app.$i18n.t("Bonification"),
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [9]
        key: "salary_per_day",
        label: app.$i18n.t("Salary Per Day"),
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [10]
        key: "worked_days",
        label: app.$i18n.t("Assisted"),
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [11]
        key: "not_worked_days",
        label: app.$i18n.t("Not Assisted"),
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [12]
        key: "pension_name",
        label: "Sistema de pensiones",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [13]
        key: "tipo_comision",
        label: "TIPO COMISION",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [14]
        key: "porcentaje_contribucion",
        label: "% Contribución",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [15]
        key: "monto_contribucion",
        label: "DSC. Contribución",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [16]
        key: "porcentaje_seguro",
        label: "% Seguro",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [17]
        key: "monto_seguro",
        label: "DSC. Seguro",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [18]
        key: "porcentaje_comision",
        label: "% Comisión",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
    },
    {
        // [19]
        key: "monto_comision",
        label: "DSC. Comisión",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [20]
        key: "total_aportaciones",
        label: "DSC. Tot. Aportaciones",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [21]
        key: "descuento_x_falta",
        label: "DSC. Faltas",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [22]
        key: "descuento_x_tardanza",
        label: "DSC. Tardanzas",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [23]
        key: "other_discounts",
        label: "DSC. Otros",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [24]
        key: "monto_quinta",
        label: "DSC. RET. Quinta",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [25]
        key: "total_discounts",
        label: "Descuentos",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [26]
        key: "bono_quincena",
        label: "1ra. Quincena Bono",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [26]
        key: "bono_mensual",
        label: "2da. Quincena Bono",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [26]
        key: "fortnight_amount",
        label: "1ra. Quincena Sueldo",
        tdClass: "text-center",
        thClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [27]
        key: "monthly_amount",
        label: "2da. Quincena Sueldo",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        key: "or_salary",
        label: "Salario Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_bonification",
        label: "Bonificacion Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_monthly_descuento_tardanza",
        label: "Dsc. Tardanza Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_montlhy_descuento_falta",
        label: "Dsc. Faltas Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_monthly_others_discount",
        label: "Dsc. Otros Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_total_descuento",
        label: "Total Descuento Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_bono_quincena",
        label: "1ra. Quincena Bono Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        key: "or_bono_mensual",
        label: "2da. Quincena Bono Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        variant: 'info',
        visible: true,
        sortable: true,
    },
    {
        // [28]
        key: "or_fortnight_amount",
        label: "1ra. Quincena Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [29]
        key: "or_total_amount",
        label: "2da. Quincena Adicional",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [30]
        key: "payroll_status",
        label: app.$i18n.t("Status"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
        sortable: true,
    },
    {
        // [31]
        key: "actions",
        label: app.$i18n.t("Actions"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    }
];
